import React, { Suspense } from "react";
import { Link } from "react-router-dom";
import LoadingBar from "components/LoadingBar";

import styles from "./PlantBackground.module.css";

const PlantBackground = (props) => {
  const { children, layoutClassName } = props;

  return (
    <Suspense fallback={<LoadingBar />}>
      <div className={`${styles.layout} ${layoutClassName || ''}`}>
        <main className={styles.pageContent}>
          <Link to="/">
            <div className={styles.logo} />
          </Link>
          {children}
        </main>
      </div>
    </Suspense>
  );
};

export default PlantBackground;
